import type { TOC } from '@ember/component/template-only'
import type { LessonDataViewModel } from 'teacher-ui-client/subscription-type/lessons/fast-phonics/previews/template'
import { t } from 'ember-intl'
import joinList from 'teacher-ui-client/helpers/join-list'

interface Args {
  lessonData: LessonDataViewModel
}

interface Signature {
  Args: Args
}

export const FastPhonicsLessonData: TOC<Signature> = <template>
  <p>{{t "components.tiles.lessonPreviewEntry.phase"}} {{@lessonData.phase}}</p>
  {{#if @lessonData.focusSounds}}
    <p class="text-sm">
      <dt class="font-semibold">{{t "components.tiles.lessonPreviewEntry.lessonData.focusSounds"}}</dt>
      <dd>{{joinList @lessonData.focusSounds ", "}}</dd>
    </p>
  {{/if}}
  {{#if @lessonData.wordsRead}}
    <p class="text-sm">
      <dt class="font-semibold">{{t "components.tiles.lessonPreviewEntry.lessonData.wordsRead"}}</dt>
      <dd>{{joinList @lessonData.wordsRead ", "}}</dd>
    </p>
  {{/if}}
</template>

export default FastPhonicsLessonData
